import type {
  DomesticServiceRateSummaryRow,
  DomesticServiceRateSummaryWarning,
} from '@/services/api';

const WARNING_LABELS: Record<DomesticServiceRateSummaryWarning, string> = {
  negative_rate: 'Contains negative rates',
  zero_rate: 'Contains zero rates',
  missing_rates: 'Some NPANXX codes have missing rates',
  excluded_non_npanxx_rows: 'Excluded rows that are not six-digit domestic NPANXX codes',
  deck_unavailable: 'The applicable Rate Deck artifact is unavailable',
  effective_version_conflict: 'More than one Rate Deck has the same effective rank',
  rate_rows_conflict: 'The Rate Deck contains conflicting rows',
  no_domestic_npanxx: 'No six-digit domestic NPANXX codes are available',
  summary_failed: 'The Rate Deck could not be summarized',
};

export function formatAverageRate(value: string | null): string {
  return value === null ? '—' : value;
}

export function effectiveDeckLabel(row: DomesticServiceRateSummaryRow): string {
  if (row.providerDeckId === null) return '—';
  const effectiveDate = row.effectiveStart?.slice(0, 10) ?? 'date unavailable';
  return `Deck ${row.providerDeckId} · ${effectiveDate}`;
}

export function summaryStatusLabel(row: DomesticServiceRateSummaryRow): string {
  if (row.status === 'ready') return 'Ready';
  if (row.status === 'warning') return 'Check warnings';
  if (row.status === 'unavailable') return 'Deck unavailable';
  if (row.status === 'conflict') return 'Conflict';
  if (row.status === 'no_data') return 'No NPANXX';
  return 'Failed';
}

export function summaryWarningText(row: DomesticServiceRateSummaryRow): string {
  return row.warnings.map((warning) => WARNING_LABELS[warning]).join('. ');
}

export function isLowestAverageIntrastate(
  row: DomesticServiceRateSummaryRow,
  rows: DomesticServiceRateSummaryRow[],
): boolean {
  return row.rates.intrastate.average !== null
    && rows.find((candidate) => candidate.rates.intrastate.average !== null) === row;
}
